"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  fade: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    animationName: "$fade",
    animationDuration: "8s",
    animation: "8s fade infinite ease-in-out",
    zIndex: "0",
    transition: "2s"
  },
  "@keyframes fade": {
    "0%": {
      left: "-200px",
      top: "0px",
      opacity: 0
    },
    "20%": {
      left: "0px",
      top: "0px",
      opacity: 1
    },
    "40%": {
      left: "0px",
      top: "0px"
    },
    "60%": {
      left: "0px",
      top: "0px"
    },
    "100%": {
      left: "100%",
      top: "0px"
    }
  },
  center: {
    display: "flex",
    justifyContent: "center"
  },
  image: {
    width: "80%",
    borderRadius: "20px"
  },
  title: function title(props) {
    return {
      fontFamily: "IranSansX",
      fontSize: "36px",
      lineHeight: "56px",
      marginTop: "75px",
      color: _variables.colors[props.textColor]
    };
  },
  text: function text(props) {
    return {
      fontFamily: "IranSansX",
      fontSize: "24px",
      lineHeight: "37px",
      marginTop: "20px",
      textAlign: "center",
      color: _variables.colors[props.textColor]
    };
  },
  dot: function dot(props) {
    return {
      cursor: "pointer",
      height: "15px",
      width: "15px",
      margin: "0 2px",
      backgroundColor: _variables.colors[props.textColor],
      borderRadius: "50%",
      display: "inline-block",
      transition: "background-color 0.6s ease",
      opacity: "50%"
    };
  },
  active: function active(props) {
    return {
      backgroundColor: _variables.colors[props.textColor],
      opacity: "100%"
    };
  },
  sliderCounter: {
    textAlign: "center",
    marginTop: "30px"
  },
  slides: {
    display: "none"
  },
  block: {
    display: "block !important"
  },
  sliderBox: {
    width: "100%",
    overflow: "hidden",
    position: "relative"
  }
}), {
  name: 'pds-slider'
});
exports.useStyles = useStyles;